const styles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
    },
    autoComplete: {
        '.MuiOutlinedInput-root': {
            borderRadius: '16px 0 0 16px',
            width: '400px',
        },
    },
    button: {
        borderRadius: '0 16px 16px 0',
        height: '40px',
        borderColor: '#d6d6d6',
    },
    paperProps: {
        width: '460px',
        fontFamily: 'Silka',
        fontWeight: 600,
        fontSize: '16px',
        backgroundColor: '#F7F8FC',
        borderRadius: '5px 5px 5px 5px',
        position: 'absolute',
        left: 120,
        top: 150,
        maxHeight: '350px',
    },
    buttonLayout: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        flexDirection: 'row',
        height: '70px',
        fontFamily: 'Silka_Bold',
        mt: 2,
        mb: 2,
    },
    filterButtons: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '14px',
    },
};

export default styles;
